import i18n from '../language/index'
import PersonBase from './row_jcp';
import { saveForm } from '@/api/app';
import Store from '../vuex/store';
import zhToPinyin from '@/base/zh-to-pinyin'
import router from '@/router'
import {
  getProList,
  wmRecommend,
  getProTypeList
} from '@/api/app';

export default class Person_J_Templet extends PersonBase {
  constructor(...args) {
    super(...args);
    let that = this;
  }
  /* 根据ID获取表单*/
  getFormById(formId) {
    let form = {}
    const list = Store.state.app.formList.filter((item, index) => { return item.id === formId });
    if (list.length > 0) {
      form = list[0]
    }
    return form
  }
  /* 表单去重*/
  form_unique() {
    let obj = Store.state.app.se_form_id
    let arr = []
    for (let key in obj) {
      if (obj[key] !== '') {
        arr.push(obj[key])
      }
    }
    return Array.from(new Set(arr))
  }

  /* 保存改变的表单*/
  async saveChangeForm() {
    let that = this
    let arr = that.form_unique()
    try{
      for (var item of arr) {
        if (item !== '') {
          let form = that.getFormById(item)
          if (typeof form.id !== 'undefined') {
            await that.addForm(form)
          }
        }
      }
    }catch(err){       
    }finally{
      this.getFormList()     
    }
  }
  /* 保存当前的表单*/
  saveForm() {
    let formList = Store.state.app.formList
    let se_id = Store.state.app.module_Data.data.listArr.id
    const list = formList.filter((item, index) => { return item.id == se_id });
    if (list.length > 0) {
      const form = list[0]
      this.addForm(form, false)
    }
  }
  // 格式化数据
  formatData(data) {
    let numberIndex = 0
    data.contentList.forEach((item) => {
      if (item.name === '') {
        if (Store.state.add_form.form_type === 'edit') {
          // 编辑表单项
          let number = this.getNumberIndex(data.contentList)
          item.name = 'field' + number
        } else {
          // 新增表单项
          item.name = 'field' + numberIndex
          numberIndex++
        }
      }
    })
    return data
  }
  getNumberIndex(list) {
    let newArr = []
    list.forEach((item) => {
      if (item.name !== '' && item.name.indexOf('field') > -1) {
        newArr.push(item.name)
      }
    })
    let number = 0;
    for (let i = 0; i < 16; i++) {
      let value = 'field' + i
      if (newArr.indexOf(value) == -1) {
        number = i;
        break;
      }

    }
    return number
  }
  getFormName(list) {
    let newArr = []
    list.forEach((item, index) => {
      if (item.title !== '') {
        newArr.push(item.title)
      }
    })
    let number = 0;
    for (let i = 1; i < 100; i++) {
      let value = i18n.t('base_row_ml_1922') + i
      if (newArr.indexOf(value) == -1) {
        number = i;
        break;
      }

    }
    return i18n.t('base_row_ml_1922') + number
  }
  async addForm(form) {
    return new Promise((resolve, reject) => {
    let files = form.fields
    if (typeof files == 'string') {
      files = JSON.parse(files)
    }
    let newFiles = this.formatData(files)
    form.fields = JSON.stringify(newFiles)
      saveForm({
        id: form.id,
        title: form.title,
        fields: form.fields
      }).then((e) => {
        if (e.code == 200) {
          resolve('true')
        } else {
          this.p_$message.warning(e.message || e.error);
          reject('false')
        }
      }).catch((res) => {
        this.p_$message.warning(res.message || res.error);
        reject('false')
      })
    })
  }
  proUnique(arr) {
    let hash = {};
    const tempArr = arr.reduce((preVal, curVal) => {
      hash[curVal.id] ? '' : hash[curVal.id] = true && preVal.push(curVal);
      return preVal
    }, [])
    return tempArr
  }
  /* 获取产品列表 */
  // 获取产品列表
  get_product(that_data, type = 'index') {
    var that =this
    //请求产品列表，产品列表的参数需要重新判断，是传ids还是category_id
    if (that_data.listArr.type === 'label' && !router.history.current.query.tag_id) {
      that_data.list = []
      that_data.se_list = []
      return;
    }
    that_data.loading = true;

    function toThen(e) {
      if (
        e.code == 200 &&
        e.data &&
        e.data.rows &&
        e.data.rows instanceof Array
      ) {
        that_data.total = e.data.total;
        //list是组件index.vue中渲染试图的变量
        //不同的分页，渲染方式不同
        if (type == 'index') {
          const page = that_data.module.data.pc_widgets_infor.page
          if (page.radioValue && page.pageStyle == 2) {
            //展开更多，数据插入，不是数据重写
            if (that_data.isReset) {
              that_data.isReset = false
              that_data.list = []
            }
            e.data.rows.map((item) => {
              item.id = item.goods_id;
              that_data.list.push(item);
            });
          } else {
            that_data.list = that.pro_data_filter(e.data.rows);
          }
          if (!that_data.pc_infor.page.radioValue) {
            if (!that_data.pc_infor.showAll) {
              that_data.list = that_data.list.slice(0, that_data.pc_infor.showNum)
            } else {
              that_data.list = that_data.list.slice(0, 200)
            }
          }
        } else {
          that_data.se_list = that.pro_data_filter(e.data.rows);
        }
      }
    }
    
    if (that_data.listArr.type === 'system') {
      wmRecommend(this.pro_request_data_filter(that_data))
        .then(e => {
          toThen(e)
        }).finally(() => {
          that_data.loading = false;
        });
    }else{
      getProList(this.pro_request_data_filter(that_data))
        .then(e => {
          toThen(e)
        }).finally(() => {
          that_data.loading = false;
        });
    }
    
  }


  pro_data_filter(list) {
    return list.map((item) => {
      item.id = item.goods_id;
      item.name = item.name;
      return item;
    });
  }
  //根据类型确定参数
  pro_request_data_filter(that_data) {
    //做分页判断
    const data = this.pro_has_page(that_data);
    let data_req = {is_up: 'true',...data}

    if (that_data.listArr.type === 'custom') { // 直接添加
      data_req.ids = this.request_data_judge(that_data.listArr.custom);
    }
    if(that_data.listArr.type === 'systom'){ // 筛选分类
      data_req.type_ids = this.request_data_judge(that_data.listArr.catalog_id);
      data_req.sort = that_data.listArr.sortBy
      data_req.order = that_data.listArr.sort
    }
    console.log('routerrouter', router);
    if (that_data.listArr.type === 'system') {
      data_req = {
        is_up: 'true',
        type: ['article', 'help', 'case'].indexOf(router.history.current.name) + 1,
        page: data_req.page ? data_req.page : 1, 
        rows: data_req.rows ? data_req.rows : 100,
        id: router.history.current.query.id,
        self: router.history.current.name == 'product' ? 1 : 0
      }
    }

    if(that_data.listArr.type === 'label') { // 标签添加 标签产品 发送 tag_id 标签id是通过url传递过来的
      data_req.tag_id = router.history.current.query.tag_id
      // console.log(router.history.current.query)
      // 这边 要判断 路由 是不是在产品详情页面 要是在产品详情页面 要发送产品的id 
      if(router.history.current.name==='product') data_req.sameId = router.history.current.query.id
    }
    //系统添加的就是listArr.type = all
    if (that_data.listArr.type === 'all') {
      data_req.type_id = that_data.proTypeId
      data_req.name = that_data.keyword
      data_req.sort = that_data.listArr.sortBy
      data_req.order = that_data.listArr.sort
    }
    return data_req;
  }
  //分页判断
  pro_has_page(that_data) {
    let data = {}
    //判断是index还是edit 产品展示模块样式除轮播图外都可以分页
    if (that_data.module && that_data.module.data) {
      let page = that_data.module.data.pc_widgets_infor.page

      if (that_data.listArr.module_style !== 1 && page.radioValue) {
        //需要分页
        data.rows = page.pageSize;
        data.page = that_data.currentPage;
      }
      else {
        data.rows = 999999;
        data.page = 1;
      }
    }

    return data;

  }
  //校验表单项内容是否存在
  checkFormItemContentValue(typeValue) {
    if (typeof typeValue.form_item_content == 'undefined') {
      this.p_$set(typeValue, 'form_item_content', {});
      this.p_$set(typeValue.form_item_content, 'radio_val', 'default');
    }
    if (typeof typeValue.form_item_content.default == 'undefined') {
      this.p_$set(typeValue.form_item_content, 'default', {});
      this.p_$set(typeValue.form_item_content.default, 'fsItalics', 'normal');
      this.p_$set(typeValue.form_item_content.default, 'fontUnderline', 'none');
      this.p_$set(typeValue.form_item_content.default, 'fsWeight', 'normal');
      this.p_$set(typeValue.form_item_content.default, 'fontSize', 14);
      this.p_$set(typeValue.form_item_content.default, 'fontColor', 'rgba(51,51,51,1)');
      this.p_$set(typeValue.form_item_content.default, 'fontFamily', 'Arial');
      this.p_$set(typeValue.form_item_content.default, 'textAlign', 'left');
      this.p_$set(typeValue.form_item_content.default, 'pattern', 'pure_color');
      if (typeof typeValue.form_item_content.default.linear_gradient == 'undefined') {
        this.p_$set(typeValue.form_item_content.default, 'linear_gradient', {});
        this.p_$set(typeValue.form_item_content.default.linear_gradient, 'start_color', 'rgba(156,40,177,1)');
        this.p_$set(typeValue.form_item_content.default.linear_gradient, 'end_color', 'rgba(0, 0, 0,1)');
        this.p_$set(typeValue.form_item_content.default.linear_gradient, 'start_pointer', 12);
        this.p_$set(typeValue.form_item_content.default.linear_gradient, 'end_pointer', 100);
        this.p_$set(typeValue.form_item_content.default.linear_gradient, 'deg', 0);
      }
    }
    if (typeof typeValue.form_item_content.custom == 'undefined') {
      this.p_$set(typeValue.form_item_content, 'custom', {});
      this.p_$set(typeValue.form_item_content.custom, 'fsItalics', 'normal');
      this.p_$set(typeValue.form_item_content.custom, 'fontUnderline', 'none');
      this.p_$set(typeValue.form_item_content.custom, 'fsWeight', 'normal');
      this.p_$set(typeValue.form_item_content.custom, 'fontSize', 14);
      this.p_$set(typeValue.form_item_content.custom, 'fontColor', 'rgba(51,51,51,1)');
      this.p_$set(typeValue.form_item_content.custom, 'fontFamily', 'Arial');
      this.p_$set(typeValue.form_item_content.custom, 'textAlign', 'left');
      this.p_$set(typeValue.form_item_content.custom, 'pattern', 'pure_color');
      if (typeof typeValue.form_item_content.custom.linear_gradient == 'undefined') {
        this.p_$set(typeValue.form_item_content.custom, 'linear_gradient', {});
        this.p_$set(typeValue.form_item_content.custom.linear_gradient, 'start_color', 'rgba(156,40,177,1)');
        this.p_$set(typeValue.form_item_content.custom.linear_gradient, 'end_color', 'rgba(0, 0, 0,1)');
        this.p_$set(typeValue.form_item_content.custom.linear_gradient, 'start_pointer', 12);
        this.p_$set(typeValue.form_item_content.custom.linear_gradient, 'end_pointer', 100);
        this.p_$set(typeValue.form_item_content.custom.linear_gradient, 'deg', 0);
      }
    }
  }



}



// WEBPACK FOOTER //
// ./src/base/row_ml.js